angular.module('unica_grand_prix.grand_prix_services')

.factory('GrandPrixRankingSendService', function ($http, getBaseApiURL) {

	var grandPrixRankingSendService = {};

	grandPrixRankingSendService.send = function ( invitationListId ) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/grand-prix/ranking/send-pre-invitations/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};


	return grandPrixRankingSendService;
});